import { useTranslation } from "react-i18next";

/** FR-059: "EN VI Khmer" — short codes for English and Vietnamese, but Khmer spelled out, since
 * "KM" meant nothing to users. Labels set explicitly by the product owner (2026-09-02); an
 * earlier pass used each language's endonym ("Tiếng Việt", "ខ្មែរ") and was changed to this. */
const LANGUAGES: { code: "en" | "vi" | "km"; label: string }[] = [
  { code: "en", label: "EN" },
  { code: "vi", label: "VI" },
  { code: "km", label: "Khmer" },
];

/** FR-023: lets anyone switch the UI's language regardless of role — rendered once in the
 * shared `AppHeader` so it's visible on every page, including the sign-in pages. */
export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  return (
    <div className="ml-auto flex gap-1">
      {LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          onClick={() => i18n.changeLanguage(lang.code)}
          aria-pressed={i18n.resolvedLanguage === lang.code}
          className={`rounded px-2 py-1 text-xs font-sans ${
            i18n.resolvedLanguage === lang.code ? "bg-brand text-surface" : "text-body hover:bg-surface-alt"
          }`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
}
